import { Box, Spinner, useMediaQuery } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { Modal } from '_app/components'
import VideoPlayer from '_app/components/VideoPlayer'

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

const DESKTOP_VIDEO_URL = 'https://vimeo.com/767229582'
const MOBILE_VIDEO_URL = 'https://vimeo.com/840430613'

export const ConfiguratorVideoModal = ({ isOpen, onClose }: Props) => {
  const [loading, setLoading] = useState(true)
  const [isLargerThan1024] = useMediaQuery('(min-width: 1024px)')
  const [isLargerThan800] = useMediaQuery('(min-width: 800px)')

  useEffect(() => {
    if (!isOpen) {
      setLoading(true)
    }
  }, [isOpen])

  const getWidth = () => {
    if (isLargerThan1024) return 1000

    return isLargerThan800 ? 600 : 250
  }

  const getHeight = () => {
    if (isLargerThan1024) return 500

    return isLargerThan800 ? 1000 : 450
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} maxWidth="none" width="auto">
      <Box
        maxWidth="100vw"
        maxHeight="calc(100vh - 4rem)"
        width={getWidth()}
        css={{
          aspectRatio: isLargerThan1024 ? '16/9' : '9/16',
        }}
        position="relative"
      >
        {loading && (
          <Spinner
            position="absolute"
            zIndex="-1"
            left="calc(50% - 0.5 * var(--spinner-size))"
            top="calc(50% - 0.5 * var(--spinner-size))"
            speed="1s"
            size="lg"
          />
        )}

        <VideoPlayer
          controls
          iframeWidth={getWidth()}
          iframeHeight={getHeight()}
          loop={false}
          playsinline={false}
          muted={false}
          width="100%"
          height="100%"
          url={isLargerThan1024 ? DESKTOP_VIDEO_URL : MOBILE_VIDEO_URL}
          onReady={() => setLoading(false)}
        />
      </Box>
    </Modal>
  )
}
